import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { Container, Form } from 'react-bootstrap';
import DatePicker from 'components/common/DatePicker';
import Select from 'react-select';

// Services & Helpers
import GlobalStateService from 'services/GlobalStateService';
import ReportService from 'services/ReportService';
import VendorService from 'services/VendorService';

// Components
import Loader from 'components/common/Loader';
import PageHeader from 'components/common/PageHeader';
import SideBar from 'components/common/SideBar';
import FormChecks from 'components/common/FormChecks';
import ReportResults from 'components/report/ReportResults';

//-------------------------------------------------------------------------------------------------------------------

class ReportsPage extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoadingVendors: true,
            isLoadingReports: true,
            isLoadingReport: false,
            isLoadingResults: false,
            paramValues: {},
            lastParamValues: {},
            isDirty: false,
            version: 1,
            reportSlug: props.match.params.slug
        };
    }

    componentDidMount() {
        GlobalStateService.setValues({ area: 'reports' });
        window.scrollTo(0, 0);
        this.loadVendors();
    }

    //componentDidUpdate(oldProps) {
    //    if (this.props.match.params.slug != oldProps.match.params.slug) {
    //        this.setState({
    //            results: null
    //        });
    //        this.loadReport();
    //    }
    //}

    async loadVendors() {
        const paramValues = { ...this.state.paramValues };
        this.setState({ isLoadingVendors: true });
        const vendors = await VendorService.list();
        if (!paramValues['vendor-id']) {
            paramValues['vendor-id'] = vendors[0].id;
        }

        this.setState({
            vendors,
            paramValues,
            isLoadingVendors: false,
            isLoadingReports: true
        }, () =>
            this.loadReports()
        );
    }

    async loadReports() {
        const vendorID = this.state.paramValues['vendor-id'];
        this.setState({ isLoadingReports: true });
        const reports = await ReportService.list({ vendorID });
        this.setState({
            reports,
            isLoadingReports: false
        }, () => {
            this.loadReport();
        });
    }

    setReport(reportSlug) {
        this.props.history.push(`/reports/${reportSlug || ''}`);
        this.setState({
            reportSlug,
            results: null,
            report: null
        }, () => {
            if (reportSlug) {
                this.loadReport();
            } else {
                this.loadReports();
            }
        });
    }

    async loadReport() {
        const { reportSlug } = this.state;
        if (reportSlug) {
            this.setState({ isLoadingReport: true });

            // Load report
            const report = await ReportService.get(reportSlug);

            // Default parameter values
            const paramValues = { };
            const vendorID = this.state.paramValues['vendor-id'];
            report.params.forEach(p => {
                let value = p.defaultValue;
                switch (p.dataType) {
                    case 'Date':
                        value = value ? new Date(value) : '';
                        break;
                    case 'SingleSelect':
                        if (!value && p.options.length > 0) {
                            value = p.options[0].value;
                        }
                        break;
                    case 'MultiSelect':
                        if (!value) {
                            value = {}
                            p.options.forEach(o => {
                                if (o.isSelected) {
                                    value[o.value] = true;
                                }
                            });
                        }
                        break;
                }
                paramValues[p.code] = value;
            });
            paramValues['vendor-id'] = vendorID;

            this.setState({
                isLoadingReport: false,
                report,
                paramValues
            });
        } else {
            this.setState({
                isLoadingReport: false,
                report: null
            });
        }
    }

    async runReport() {
        if (this.state.report.isExcelOnly) {
            return;
        }
        this.setState({
            isLoadingResults: true,
            isDirty: false,
            results: null,
            version: this.state.version + 1
        });
        this.lastParamValues = { ...this.state.paramValues };
        const results = await ReportService.run(this.state.report.slug, {
            paramValues: this.state.paramValues
        });
        this.setState({
            isLoadingResults: false,
            results: results
        });
    }

    async exportToExcel() {
        await ReportService.excel(this.state.report.slug, {
            paramValues: this.state.paramValues
        });
    }

    updateParamValue(paramCode, value, save) {
        const paramValues = { ...this.state.paramValues };
        paramValues[paramCode] = value;
        this.setState({
            paramValues
        }, () => {
            if (save) {
                this.saveParamValue(paramCode);
            }
            if (paramCode == 'vendor-id') {
                this.loadReports();
            }
        });
    }

    saveParamValue(paramCode) {
        if (this.state.paramValues && this.lastParamValues && this.state.paramValues[paramCode] != this.lastParamValues[paramCode]) {
            this.setState({ isDirty: true });
        }
    }

    render() {
        const { report, results } = this.state;
        const loginInfo = GlobalStateService.getValue('loginInfo');

        return (<>

            <div className="page reports-page full-width-page">

                <PageHeader hasSideBar>
                    <h1>{report ? report.name : 'Reports'}</h1>

                    {report && (results || report.isExcelOnly) && loginInfo.site.enableExcelExport && 
                        <div className="buttons">
                            <button className="btn btn-primary" onClick={e => this.exportToExcel()}>
                                <span className="fa-solid fa-file-excel" />{' '}
                                Export
                            </button>
                        </div>
                    }

                </PageHeader>

                <main>

                    <SideBar content={this.renderSideBarContent()} className="flex" />

                    <Container fluid>

                        <section>

                            {this.renderInner()}

                        </section>

                    </Container>

                </main>

            </div>

        </>);
    }

    renderSideBarContent() {
        const {
            report,
            reports,
            isLoadingReport,
            isLoadingReports,
            isLoadingResults,
            isDirty,
            paramValues,
            vendors
        } = this.state;

        if (report) {
            if (isLoadingReport) {
                return (<Loader fullPage />);
            }

            return (<>

                <button className="btn btn-secondary w-100" onClick={() => this.setReport(null)}>
                    <span className="fa-solid fa-chevron-left" />{' '}
                    Go back to report list
                </button>

                <hr />

                {report.params.length == 0 &&
                    <div className="empty-text">
                        This report has <br />
                        no parameters
                    </div>
                }

                <div className="parameters-panel">

                    {report.params.map(p =>
                        <React.Fragment key={p.code}>
                            {this.renderParam(p)}
                        </React.Fragment>
                    )}

                </div>

                {!report.isExcelOnly &&
                    <button type="button" className="btn btn-primary w-100 mt-auto" onClick={() => this.runReport()} disabled={isLoadingResults}>
                        Run report {isDirty ? ' *' : ''}
                    </button>
                }
            </>);
        } else {
            if (isLoadingReports || isLoadingReport) {
                return (<Loader fullPage />);
            }

            return (<>

                <Form.Group className="mb-3">
                    <Form.Label>Vendor</Form.Label>
                    <Select
                        className="react-select-container"
                        classNamePrefix="react-select"
                        value={paramValues['vendor-id'] ? vendors.find(v => v.id == paramValues['vendor-id']) : null}
                        options={vendors}
                        getOptionValue={v => v.id}
                        getOptionLabel={v => v.name}
                        onChange={v => this.updateParamValue('vendor-id', v.id, true)}
                    />
                </Form.Group>

                <div className="btn-stack">
                    {reports.map(r =>
                        <button key={r.slug} type="button" className={`btn btn-secondary`} onClick={() => this.setReport(r.slug)}>
                            {r.name}
                            {r.isGoCoursesOnly && <>
                                {' '}<span className="fa-solid fa-lock" title="Go Courses only" />
                                {r.isSiteAdminOnly &&
                                    <>{' '}<span className="fa-solid fa-lock" title="Super Admin only" /></>
                                }
                            </>}
                        </button>
                    )}
                </div>
            </>);
        }
    }

    renderParam(param) {
        const {
            paramValues
        } = this.state;

        switch (param.dataType) {
            case 'Date':
                return (
                    <Form.Group className="mb-3">
                        <Form.Label>{param.name}</Form.Label>
                        <DatePicker
                            className="form-control"
                            selected={paramValues[param.code] || null}
                            onChange={value => this.updateParamValue(param.code, value, false)}
                            onSelect={value => this.updateParamValue(param.code, value, true)}
                            onBlur={e => this.saveParamValue(param.code)}
                        />
                    </Form.Group>
                );
                break;
            case 'SingleSelect':
                return (
                    <Form.Group className="mb-3">
                        <Form.Label>{param.name}</Form.Label>
                        <select
                            className="form-control"
                            value={paramValues[param.code] || ''}
                            onChange={e => this.updateParamValue(param.code, e.target.value, true)}
                        >
                            {param.options.map(po =>
                                <option key={po.value} value={po.value}>{po.text}</option>
                            )}
                        </select>
                    </Form.Group>
                );
                break;
            case 'MultiSelect':
                return (<>
                    <FormChecks
                        isScrolling
                        allowSelectAllNone
                        isConcertina
                        includeFormGroup
                        className="mb-3"
                        name={param.name}
                        id={`param-${param.code}`}
                        options={param.options.map(o => ({
                            id: o.value,
                            name: o.text
                        }))}
                        value={paramValues[param.code] || ''}
                        onChange={options => {
                            const value = { ...paramValues[param.code] };
                            for (let optionValue in options) {
                                if (options[optionValue]) {
                                    value[optionValue] = true;
                                } else {
                                    delete value[optionValue];
                                }
                            }
                            this.updateParamValue(param.code, value, true);
                        }}
                    />
                </>);
        }
        return null;
    }

    renderInner() {
        const {
            isLoadingResults,
            report,
            results,
            version
        } = this.state;

        if (isLoadingResults) {
            return (<Loader fullPage />);
        }
        if (!report) {
            return (
                <div className="empty-text">
                    Use the menu to select a report
                </div>
            );
        }
        if (report.isExcelOnly) {
            return (
                <div className="empty-text">
                    This is an Excel-only report. Please press the Export button to download it.
                </div>
            );
        }
        if (!results) {
            return (
                <div className="empty-text">
                    Please press 'Run report'.
                </div>
            );
        }

        // Remove hidden columns
        results.columns = results.columns.filter(c => !c.isHidden);
        return (
            <ReportResults results={results} version={version} />
        );
    }

}

export default withRouter(ReportsPage);